var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLargeConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8504 13.6923C15.8504 17.3147 12.9171 20.25 9.3002 20.25C5.68335 20.25 2.75 17.3147 2.75 13.6923C2.75 10.0698 5.68335 7.13458 9.3002 7.13458C12.9171 7.13458 15.8504 10.0698 15.8504 13.6923Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2501 9.3077C21.2501 12.9301 18.3167 15.8654 14.6999 15.8654C11.083 15.8654 8.14966 12.9301 8.14966 9.3077C8.14966 5.68526 11.083 2.75 14.6999 2.75C18.3167 2.75 21.2501 5.68526 21.2501 9.3077Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeConnection);
export default __webpack_public_path__ + "static/media/largeConnection.a9eb411cf412c9091f1bd4c29bc011a6.svg";
export { ForwardRef as ReactComponent };